import { defineMessages } from 'react-intl';

export default defineMessages({
  tableTitle: {
    id: 'adjustments.tableTitle',
    defaultMessage: 'Adjustments',
  },
  status: {
    id: 'adjustments.status',
    defaultMessage: 'Status',
  },
  headOfHousehold: {
    id: 'adjustments.headOfHousehold',
    defaultMessage: 'Head of Household',
  },
  unit: {
    id: 'adjustments.unit',
    defaultMessage: 'Unit',
  },
  hudUnitNumber: {
    id: 'adjustments.hudUnitNumber',
    defaultMessage: 'HUD Unit #',
  },
  hudUnitNumberTooltip: {
    id: 'adjustments.hudUnitNumberTooltip',
    defaultMessage:
      'If the HUD Contract Unit # differs from Fortress, it will appear here (if entered) ' +
      'and be reflected on the voucher sent to TRACS. To add one, open the unit and enter ' +
      'the HUD Unit # in General Unit Information.',
  },
  priorOrNew: {
    id: 'adjustments.priorOrNew',
    defaultMessage: 'Prior/New Billing',
  },
  newCert: {
    id: 'adjustments.newCert',
    defaultMessage: 'New Cert',
  },
  certType: {
    id: 'adjustments.certType',
    defaultMessage: 'Cert Type',
  },
  effectiveDate: {
    id: 'adjustments.effectiveDate',
    defaultMessage: 'Effective Date',
  },
  assistancePayment: {
    id: 'adjustments.assistancePayment',
    defaultMessage: 'Assistance Payment',
  },
  requested: {
    id: 'adjustments.requested',
    defaultMessage: 'Requested',
  },
  approvedAmount: {
    id: 'adjustments.approvedAmount',
    defaultMessage: 'Approved Amount',
  },
  adjustmentBeginDate: {
    id: 'adjustments.adjustmentBeginDate',
    defaultMessage: 'Adjustment Begin Date',
  },
  adjustmentEndDate: {
    id: 'adjustments.adjustmentEndDate',
    defaultMessage: 'Adjustment End Date',
  },
  daysBeginningPartialMonth: {
    id: 'adjustments.daysBeginningPartialMonth',
    defaultMessage: '# of Days (Beginning Partial Month)',
  },
  dailyRateBeginningPartialMonth: {
    id: 'adjustments.dailyRateBeginningPartialMonth',
    defaultMessage: 'Daily Rate (Beginning Partial Month)',
  },
  fullMonths: {
    id: 'adjustments.fullMonths',
    defaultMessage: '# of Full Months',
  },
  fullMonthlyRate: {
    id: 'adjustments.fullMonthlyRate',
    defaultMessage: 'Full Monthly Rate',
  },
  daysEndingPartialMonth: {
    id: 'adjustments.daysEndingPartialMonth',
    defaultMessage: '# of Days (Ending Partial Month)',
  },
  dailyRateEndingPartialMonth: {
    id: 'adjustments.dailyRateEndingPartialMonth',
    defaultMessage: 'Daily Rate (Ending Partial Month)',
  },
  calculationDetailsAmount: {
    id: 'adjustments.calculationDetailsAmount',
    defaultMessage: 'Calculation Details Amount',
  },
  emptyStateMessage: {
    id: 'adjustments.emptyStateMessage',
    defaultMessage: 'No adjustments found',
  },
  loadError: {
    id: 'adjustments.loadError',
    defaultMessage: 'Unable to load voucher adjustments.',
  },
  updateApprovedAmountSuccess: {
    id: 'adjustments.updateApprovedAmountSuccess',
    defaultMessage: 'Approved amount updated successfully.',
  },
  updateApprovedAmountError: {
    id: 'adjustments.updateApprovedAmountError',
    defaultMessage: 'Unable to update approved amount. Please try again.',
  },
});
